import { ModuleType } from "../../templates/types";
import type { CalendarModuleSettings } from "./Calendar/CalendarModuleModel";
import type { CheckboxModuleSettings } from "./CheckboxModule/CheckboxModuleModel";
import type { PollModuleSettings } from "./PollModule/PollModuleModel";
import type { RsvpModuleSettings } from "./RsvpModule/RsvpModuleModel";
import type { TrackerModuleSettings } from "./TrackerModule/TrackerModuleModel";

export function getDefaultSettingsForModule(
  type: ModuleType,
  // biome-ignore lint/suspicious/noExplicitAny: Because
  currentSettings: any,
) {
  if (type === ModuleType.Calendar) {
    const settings: CalendarModuleSettings = {
      minDate: null,
      maxDate: null,
      groupDays: true,
      ...currentSettings,
    };
    return settings;
  }

  if (type === ModuleType.Checkboxes) {
    const settings: CheckboxModuleSettings = {
      sortCheckedAtBottom: false,
      useTags: true,
      ...currentSettings,
    };
    return settings;
  }

  if (type === ModuleType.Poll) {
    const settings: PollModuleSettings = {
      multipleVotes: true,
      showDescription: false,
      ...currentSettings,
    };
    return settings;
  }

  if (type === ModuleType.Rsvp) {
    const settings: RsvpModuleSettings = {
      showDescription: false,
      spotsLimit: 0,
      ...currentSettings,
    };
    return settings;
  }

  if (type === ModuleType.Tracker) {
    const settings: TrackerModuleSettings = {
      options: [],
      useDailyLimit: null,
      useBucketMode: false,
      useDescription: false,
      dateStart: null,
      dateEnd: null,
      ...currentSettings,
    };
    return settings;
  }

  return currentSettings ?? null;
}
